export default __webpack_public_path__ + "static/media/app-store.f971ca73.svg";